import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { GenericButtonCardComponent } from '../../../shared/components/generic-button-card/generic-card.component';

@Component({
  selector: 'app-formly-generic-button-card',
  templateUrl: './formly-generic-button-card.component.html',
  standalone: true,
  imports: [
    GenericButtonCardComponent,
  ]
})
export class FormlyGenericButtonCardComponent extends FieldType {

  //set property "card" in Template Options:
  /**
   * 
   * "templateOptions": {
            "card": {
              "title": "xxxx"
            }
          }
   * 
   */

  constructor() {
    super();
  }

}
